import { toJS, computed, decorate, flow, observable } from 'mobx'
import axios from 'axios'
import isEqual from 'lodash.isequal'
import formatDate from '../utils/utils'

/**
 * Describes the store containing al info about the authenticated user.
 */
class NewsStore {
    // TODO get actual categories
    static STATUS_MAP = {
        'Test category': 'success',
        Security: 'danger',
        General: 'warning',
        'USD Announcements': 'secondary',
    }

    constructor() {
        /**
         * @type {Array}
         * @private
         * @observable
         */
        this.response = {}
        this.detailResponse = {}
    }

    loadNews = flow(function* (currentPage, filters) {
        const url = `/api/news/articles`

        let response = yield axios.get(url, {
            params: {
                ...filters,
                sort: '-id',
                time: new Date().valueOf(),
                page: currentPage,
                per_page: 10,
                load_relationships: true,
            },
        })
        if (!isEqual(response.data, toJS(this.response.data))) {
            this.response = response
        }
    })

    loadNewsItem = flow(function* (id) {
        const url = `/api/news/articles/${id}`
        let response = yield axios.get(url, {
            params: {
                sort: '-creation_timestamp',
                time: new Date().valueOf(),
                markdown_content: true,
                image: true,
                load_relationships: true,
            },
        })
        if (!isEqual(response.data, toJS(this.detailResponse.data))) {
            this.detailResponse = response
        }
    })

    /**
     * @computed
     * @returns {string}
     */
    get news() {
        return this.response && this.response.data
            ? this.response.data.results
            : []
    }

    /**
     * @computed
     * @returns {string}
     */
    get newsDetail() {
        if (!this.detailResponse?.data) {
            return ''
        }

        const data = { ...this.detailResponse.data }
        if (data.creation_timestamp) {
            data.creation_timestamp = formatDate(
                new Date(data.creation_timestamp)
            )
        }

        return data
    }

    get totalPages() {
        return this.response && this.response.data
            ? this.response.data._page.total_pages
            : 0
    }
}

export default decorate(NewsStore, {
    response: observable,
    detailResponse: observable,
    newsDetail: computed,
    news: computed,
})
